import { useSignUpProvider } from '../SignUpContext'
import { defineMessages, useIntl } from 'react-intl'
import { openLink } from '../../../api/iframe/requests'
import { EMAIL_PROVIDERS } from '../../../constants/navigation'
import { Text, Heading, Button, LinkButton, Flex, Box } from '@homebotapp/hb-react-component-catalog'

import styles from './Email.module.scss'

export const MSG = defineMessages({
  success: {
    id: 'NewBuyerSignUp.setPasswordStep.success',
    defaultMessage: 'Password setup email sent!'
  },
  sentTo: {
    id: 'NewBuyerSignUp.setPasswordStep.sentTo',
    defaultMessage: 'Sent to'
  },
  openEmailInNewTab: {
    id: 'NewBuyerSignUp.setPasswordStep.openEmailInNewTab',
    defaultMessage: 'Open email in new tab'
  }
})

export const SetPassword = () => {
  const intl = useIntl()
  const { email, iFramed } = useSignUpProvider()
  const { GMAIL, OUTLOOK, YAHOO } = EMAIL_PROVIDERS

  const linkProps = (provider: { title: string; url: string }) => {
    const { url } = provider

    if (iFramed) {
      return {
        onClick: () => openLink(url)
      }
    }
    return {
      href: url,
      target: '_blank',
      rel: 'noopener noreferrer'
    }
  }

  return (
    <div className={styles.emailStep}>
      <Heading textAlign='left'>{intl.formatMessage(MSG.success)}</Heading>
      <Box mb={4}>
        <Text size='sm'>{intl.formatMessage(MSG.sentTo)}</Text>
        <Button>{email}</Button>
      </Box>
      <Box>
        <Text size='sm'>{intl.formatMessage(MSG.openEmailInNewTab)}</Text>
        <Flex gap={2}>
          <LinkButton {...linkProps(GMAIL)}>{GMAIL.title}</LinkButton>
          <LinkButton {...linkProps(OUTLOOK)}>{OUTLOOK.title}</LinkButton>
          <LinkButton {...linkProps(YAHOO)}>{YAHOO.title}</LinkButton>
        </Flex>
      </Box>
    </div>
  )
}
